export default function (input) {
    return typeof input === 'boolean'
}
